import { message as t } from "./queries/message/index.js";
import { contact as r } from "./queries/contact/index.js";
import { calendars as e } from "./queries/calendars/index.js";
import { $ as o } from "./index-DVHhaa_b.js";
import { student as n } from "./queries/student/index.js";
import { settings as s } from "./queries/settings/index.js";
import { points as m } from "./queries/points/index.js";
import { assessment as i } from "./queries/assessment/index.js";
import { annotations as u } from "./queries/assessment/annotations/index.js";
import { rubrics as p } from "./queries/assessment/rubrics/index.js";
import { qcesubjects as a } from "./queries/assessment/qcesubjects/index.js";
import { extensionrequest as f } from "./queries/assessment/extensionrequest/index.js";
import { files as g } from "./queries/files/index.js";
import { attendance as c } from "./queries/attendance/index.js";
import { forms as l } from "./queries/forms/index.js";
import { notifications as d } from "./queries/notifications/index.js";
import { interviews as b } from "./queries/interviews/index.js";
import { notes as j } from "./queries/notes/index.js";
import { announcements as y } from "./queries/annoucements/index.js";
import { payments as q } from "./queries/payments/index.js";
import { analysis as w } from "./queries/assessment/analysis/index.js";
import { group as x } from "./queries/group/index.js";
import { projects as _ } from "./queries/projects/index.js";
import { courses as v } from "./queries/courses/index.js";
import { passwords as O } from "./queries/password/index.js";
const W = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get analysis() {
    return w;
  },
  get annotations() {
    return u;
  },
  get announcements() {
    return y;
  },
  get assessment() {
    return i;
  },
  get attendance() {
    return c;
  },
  get calendars() {
    return e;
  },
  get contact() {
    return r;
  },
  get courses() {
    return v;
  },
  get extensionrequest() {
    return f;
  },
  get files() {
    return g;
  },
  get forms() {
    return l;
  },
  get group() {
    return x;
  },
  get interviews() {
    return b;
  },
  get message() {
    return t;
  },
  get notes() {
    return j;
  },
  get notifications() {
    return d;
  },
  get passwords() {
    return O;
  },
  get payments() {
    return q;
  },
  get points() {
    return m;
  },
  get projects() {
    return _;
  },
  get qcesubjects() {
    return a;
  },
  get rubrics() {
    return p;
  },
  get settings() {
    return s;
  },
  get student() {
    return n;
  },
  get timetable() {
    return o;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  W as i
};
//# sourceMappingURL=index-CQkg-1By.js.map
